import { render, staticRenderFns } from "./createTraineesFeedback.vue?vue&type=template&id=641af38c&scoped=true"
import script from "./createTraineesFeedback.vue?vue&type=script&lang=js"
export * from "./createTraineesFeedback.vue?vue&type=script&lang=js"
import style0 from "./createTraineesFeedback.vue?vue&type=style&index=0&id=641af38c&prod&scoped=true&lang=css"
import style1 from "./createTraineesFeedback.vue?vue&type=style&index=1&id=641af38c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641af38c",
  null
  
)

export default component.exports